import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../../store";
import { CHARGERS } from "../../../utils/constants";
import getNavigationPathForItem from "./getNavigationPathForItem";
import { collator, getItem } from "@/utils/common";
import type { MenuItem } from "@/AppUtils";

export function useMenuHandlers() {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const {
        selectedCustomerName,
        selectedSite,
    } = useSelector((state: RootState) => state.userInfo);

    const { detailedChargerDataForSite, loadingDetailedChargerDataForSite, loadingGenDetailsForSite: loadingPower, generatorList, generatorListForMQTT, fuelGenList } = useSelector((state: RootState) => state.dashboard);

    const handleChargerMenuItemClick = useCallback((e: any) => {
        navigate(`/${selectedCustomerName}/${selectedSite}/${CHARGERS}/${e.key}`);
    }, [navigate, selectedCustomerName, selectedSite]);

    const handleMenuItemClick = useCallback((item: string) => {
        getNavigationPathForItem({
            selectedCustomerName,
            selectedSite,
            item,
            generatorList,
            generatorListForMQTT,
            fuelGenList,
            loadingPower,
            dispatch,
            navigate
        });
    }, [selectedCustomerName, selectedSite, generatorList, generatorListForMQTT, fuelGenList, loadingPower, dispatch, navigate]);

    const chargerMenuItems: MenuItem[] = useMemo(() => {
        const chargers = detailedChargerDataForSite.all_connected_chargers;
        if (chargers.length === 0) {
            return [{
                label: 'No chargers available',
                key: 'no-chargers',
                icon: undefined,
                children: null,
                disabled: true,
                style: { cursor: 'not-allowed' },
            }];
        }
        return chargers
            .map((data) => getItem(
                data.name,
                data.id + "",
                undefined,
                null,
                null,
            ))
            .sort((a, b) => collator.compare(a.label, b.label));
    }, [detailedChargerDataForSite.all_connected_chargers, loadingDetailedChargerDataForSite]);

    return { handleChargerMenuItemClick, handleMenuItemClick, chargerMenuItems };
}